import React, { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { lang } from "../../../middleware/lang";
import { LoaderDots } from "../../../middleware/loaders";
import { HeaderTitle } from "../common/titles";
import { has_access } from "../../../middleware/privileges";
import { GET_PRODUCTION_RECIPES } from "./queries";
import { ProductionRecipe } from "./models";
import InventoryNav from "./inventoryNav";

const btn = {
  txt: lang("Nueva Receta de Producción", "New Production Recipe"),
  icon: "fa fa-plus",
  link: "/inventory/production/recipes/new",
};

const ProductionRecipeList: React.FC = () => {
  const history = useHistory();
  const [search, setSearch] = useState("");

  const [fetchRecipes, { data, loading }] = useLazyQuery(
    GET_PRODUCTION_RECIPES,
    { fetchPolicy: "no-cache" }
  );

  useEffect(() => {
    fetchRecipes({ variables: { search: search || undefined, take: 100 } });
    //eslint-disable-next-line
  }, [search]);

  return (
    <>
      <HeaderTitle
        title={lang("Recetas de Producción", "Production Recipes")}
        btn={has_access(256) ? btn : null}
      />
      <InventoryNav active="production" />

      <div className="row mb-3">
        <div className="col-lg-4">
          <input
            type="text"
            className="form-control"
            placeholder={lang("Buscar receta...", "Search recipe...")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="col-lg-4 d-flex align-items-center">
          <button
            className="btn btn-outline-secondary btn-sm"
            onClick={() => history.push("/inventory/production")}
          >
            <i className="fa fa-list mr-1" />
            {lang("Ver Lotes", "View Batches")}
          </button>
        </div>
      </div>

      {loading && <LoaderDots fullSize />}

      {data && (
        <div className="row">
          <div className="col-lg-12">
            <div className="material_card p-3 table-responsive">
              <table className="table table-hover vertical_middle">
                <thead className="thead-light">
                  <tr>
                    <th>{lang("Nombre", "Name")}</th>
                    <th>{lang("Ingrediente Resultado", "Output Ingredient")}</th>
                    <th className="text-center">
                      {lang("Rendimiento", "Yield")}
                    </th>
                    <th className="text-center">
                      {lang("# Insumos", "# Inputs")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.getProductionRecipes.map((recipe: ProductionRecipe) => (
                    <tr
                      key={recipe.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        history.push(
                          `/inventory/production/recipes/edit/${recipe.id}`
                        )
                      }
                    >
                      <td className="font-weight-bold">{recipe.name}</td>
                      <td>
                        {recipe.output_ingredient?.name || "—"}
                        <small className="text-muted ml-1">
                          ({recipe.output_ingredient?.unit})
                        </small>
                      </td>
                      <td className="text-center">
                        {Number(recipe.output_quantity)} {recipe.output_unit}
                      </td>
                      <td className="text-center">
                        {recipe.inputs?.length || 0}
                      </td>
                    </tr>
                  ))}
                  {data.getProductionRecipes.length === 0 && (
                    <tr>
                      <td colSpan={4} className="text-center text-muted py-4">
                        {lang(
                          "No hay recetas de producción",
                          "No production recipes"
                        )}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductionRecipeList;
